/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gender: NonNullable<unknown>, name: NonNullable<unknown> }} Wrapped_In_TheInputs */

const en_us2_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`on ${i?.name}`)
};

const pt_br2_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	if (i?.gender === "f") return /** @type {LocalizedString} */ (`na ${i?.name}`);
	return /** @type {LocalizedString} */ (`no ${i?.name}`)
	
};

const es_419_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`en ${i?.name}`)
};

const pt_pt2_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	if (i?.gender === "f") return /** @type {LocalizedString} */ (`na ${i?.name}`);
	return /** @type {LocalizedString} */ (`no ${i?.name}`)
	
};

const fr_fr2_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sur ${i?.name}`)
};

const de_de2_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bei ${i?.name}`)
};

const it_it2_wrapped_in_the = /** @type {(inputs: Wrapped_In_TheInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`in ${i?.name}`)
};

/**
* | gender | output |
* | --- | --- |
* | * | "on {name}" |
*
* @param {Wrapped_In_TheInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_in_the = /** @type {((inputs: Wrapped_In_TheInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_In_TheInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_in_the(inputs)
	if (locale === "es-419") return es_419_wrapped_in_the(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_in_the(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_in_the(inputs)
	if (locale === "de-DE") return de_de2_wrapped_in_the(inputs)
	if (locale === "it-IT") return it_it2_wrapped_in_the(inputs)
	return en_us2_wrapped_in_the(inputs)
});
export { wrapped_in_the as "wrapped.in_the" }